class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        theme.utils.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
if (!customElements.get('search-form')) customElements.define('search-form', SearchForm);

theme.search = theme.search || {};
theme.search.normalizeTitleTerm = (searchTerm) => searchTerm.trim();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(`form[action="${routes.search_url}"]`).forEach((form) => {
    const searchInput = form.querySelector('input[type="search"][name="q"]');
    if (searchInput) {
      searchInput.value = searchInput.value
        .replace(/^title:(?:"|&quot;)/, '')
        .replace(/(?:"|&quot;)$/, '')
        .replace(/\\([\\"])/g, '$1');
    }

    form.addEventListener('submit', (event) => {
      const input = form.querySelector('input[type="search"][name="q"]');
      const searchTerm = input?.value.trim();

      if (!searchTerm) {
        event.preventDefault();
        return;
      }

      let resourceType = form.querySelector('input[name="type"]');
      if (!resourceType) {
        resourceType = document.createElement('input');
        resourceType.type = 'hidden';
        resourceType.name = 'type';
        form.append(resourceType);
      }
      resourceType.value = 'product';

      const prefixOption = form.querySelector('input[name="options[prefix]"]');
      if (prefixOption) prefixOption.value = 'last';
    });

    // Transform only the submitted data, never the customer's visible input.
    form.addEventListener('formdata', (event) => {
      const searchTerm = searchInput?.value.trim();
      if (!searchTerm) return;
      event.formData.set('q', theme.search.normalizeTitleTerm(searchTerm));
      event.formData.set('type', 'product');
      event.formData.set('options[prefix]', 'last');
    });
  });
});
